import { I18n } from "react-redux-i18n";

export const REQUIRED_MESSAGE = () => I18n.t("requiredMessage");
